const SetupKeyword = () => {

    return (
        <div id="bot-scene-container" className="">
            <div id="bot-scene-content" className="scroll-light">
                <div className="app-v2-header-wrapper has-subtitle has-extra">
                    <div className="app-v2-header-left">
                        <span className="app-v2-header-title">
                            Trả lời theo từ khóa</span>
                        <span className="app-v2-header-subtitle">
                            Tự động trả lời theo từ khóa giúp bạn phân luồng tin nhắn đúng kịch bản.
                            <a href =""target="_blank">
                                Tìm hiểu thêm
                            </a>
                        </span>
                    </div>
                    <div className="app-v2-header-extra-wrapper">
                        <button className="btn btn-primary p-sm-l p-sm-r app-v2-gtm-auto-keyword-new ml15">
                            <span>
                                + Thêm từ khóa mới
                            </span>
                        </button>
                    </div>
                </div>
                <div className="app-v2-layout-content">
                    <div >
                        <div className="hrs-filter-container-master">
                            <div className="hrs-filter-container">
                                <div className="hrs-filter-wrapper">
                                    <div className="hrs-btn-open-filter">
                                        <div className="svg-next-icon icon-filter">
                                        </div>
                                        <span>Bộ lọc tìm kiếm</span>
                                    </div>
                                </div>
                                <div className="hrs-filter-search-wrapper">
                                    <svg width="16" height="16" viewBox="0 0 16 16">
                                        <path fill="#8993A4" fillRule="evenodd"
                                            d="M6.8 13.6a6.8 6.8 0 115.34-2.59l3.626 3.624a.8.8 0 01-1.132 1.132L11.01 12.14A6.77 6.77 0 016.8 13.6zm3.728-3.175a.817.817 0 00-.103.103 5.2 5.2 0 11.102-.102z"
                                            clipRule="evenodd"></path>
                                    </svg >
                                    {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M1.33337 8.00001C1.33337 4.32001 4.32004 1.33334 8.00004 1.33334C11.68 1.33334 14.6667 4.32001 14.6667 8.00001C14.6667 11.68 11.68 14.6667 8.00004 14.6667C4.32004 14.6667 1.33337 11.68 1.33337 8.00001ZM4.66671 8.66668H11.3334V7.33334H4.66671V8.66668Z" fill="#FC625D"></path>
                                    </svg> */}
                                    <input className="hrs-filter-input-search" placeholder="Tìm kiếm" value="" />
                                </div>
                            </div>
                            <div className="hrs-condition-container mt10">
                            </div>
                        </div>
                        <div className="text-muted text-center text-biggest p-lg">
                            <span>Bạn chưa có từ khóa nào.</span>
                            <span>Bạn có thể dùng
                            <a  style={{color:"white"}}  className="btn btn-primary pd-all-2-10 app-v2-gtm-auto-keyword-new mg10">Nút này</a>
                                để tạo từ khóa mới.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SetupKeyword;